module.exports = __webpack_public_path__ + "img/wenjian@3x.f5e1756b.svg";